/* ui/game/GamePage.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import Stage from "./Stage.svelte";
import Turn from "./Turn.svelte";
import StartButton from "./StartButton.svelte";
import StopButton from "./StopButton.svelte";
import ResetButton from "./ResetButton.svelte";
import StepButton from "./StepButton.svelte";
import Scoreboard from "./Scoreboard.svelte";
import PawnStats from "./PawnStats.svelte";
import Winner from "./Winner.svelte";
import Configuration from "./configuration/Configuration.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-1qxxtl9-style";
	style.textContent = ".threeColumns.svelte-1qxxtl9{display:grid;grid-template-columns:repeat(3, 1fr);place-items:start;margin-top:-5px}.leftColumn.svelte-1qxxtl9{grid-row:1;grid-column-start:1;display:grid;grid-template-columns:repeat(3, 1fr);grid-gap:5px;place-items:center;padding:5px}.controls.svelte-1qxxtl9{grid-column:1 / span 3}.configuration.svelte-1qxxtl9{grid-column:1 / span 3}.stage.svelte-1qxxtl9{grid-row:1;grid-column-start:2}.scoreboard.svelte-1qxxtl9{grid-row:1;grid-column-start:3;margin-top:5px;padding-left:5px}.winner.svelte-1qxxtl9{z-index:10;grid-row:1;grid-column:1 / span 3;justify-self:center;align-self:center}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div5;
	let span;
	let winner;
	let t0;
	let div2;
	let div0;
	let startbutton;
	let t1;
	let stopbutton;
	let t2;
	let resetbutton;
	let t3;
	let stepbutton;
	let t4;
	let div1;
	let configuration;
	let t5;
	let div3;
	let stage;
	let t6;
	let div4;
	let turn;
	let t7;
	let scoreboard;
	let t8;
	let br;
	let t9;
	let pawnstats;
	let current;
	winner = new Winner({});
	startbutton = new StartButton({});
	stopbutton = new StopButton({});
	resetbutton = new ResetButton({});
	stepbutton = new StepButton({});
	configuration = new Configuration({});
	stage = new Stage({});
	turn = new Turn({});
	scoreboard = new Scoreboard({});
	pawnstats = new PawnStats({});

	return {
		c() {
			div5 = element("div");
			span = element("span");
			create_component(winner.$$.fragment);
			t0 = space();
			div2 = element("div");
			div0 = element("div");
			create_component(startbutton.$$.fragment);
			t1 = space();
			create_component(stopbutton.$$.fragment);
			t2 = space();
			create_component(resetbutton.$$.fragment);
			t3 = space();
			create_component(stepbutton.$$.fragment);
			t4 = space();
			div1 = element("div");
			create_component(configuration.$$.fragment);
			t5 = space();
			div3 = element("div");
			create_component(stage.$$.fragment);
			t6 = space();
			div4 = element("div");
			create_component(turn.$$.fragment);
			t7 = space();
			create_component(scoreboard.$$.fragment);
			t8 = space();
			br = element("br");
			t9 = space();
			create_component(pawnstats.$$.fragment);
			attr(span, "class", "winner svelte-1qxxtl9");
			attr(div0, "class", "controls svelte-1qxxtl9");
			attr(div1, "class", "configuration svelte-1qxxtl9");
			attr(div2, "class", "leftColumn svelte-1qxxtl9");
			attr(div3, "class", "stage svelte-1qxxtl9");
			attr(div4, "class", "scoreboard svelte-1qxxtl9");
			attr(div5, "class", "threeColumns svelte-1qxxtl9");
		},
		m(target, anchor) {
			insert(target, div5, anchor);
			append(div5, span);
			mount_component(winner, span, null);
			append(div5, t0);
			append(div5, div2);
			append(div2, div0);
			mount_component(startbutton, div0, null);
			append(div0, t1);
			mount_component(stopbutton, div0, null);
			append(div0, t2);
			mount_component(resetbutton, div0, null);
			append(div0, t3);
			mount_component(stepbutton, div0, null);
			append(div2, t4);
			append(div2, div1);
			mount_component(configuration, div1, null);
			append(div5, t5);
			append(div5, div3);
			mount_component(stage, div3, null);
			append(div5, t6);
			append(div5, div4);
			mount_component(turn, div4, null);
			append(div4, t7);
			mount_component(scoreboard, div4, null);
			append(div4, t8);
			append(div4, br);
			append(div4, t9);
			mount_component(pawnstats, div4, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(winner.$$.fragment, local);
			transition_in(startbutton.$$.fragment, local);
			transition_in(stopbutton.$$.fragment, local);
			transition_in(resetbutton.$$.fragment, local);
			transition_in(stepbutton.$$.fragment, local);
			transition_in(configuration.$$.fragment, local);
			transition_in(stage.$$.fragment, local);
			transition_in(turn.$$.fragment, local);
			transition_in(scoreboard.$$.fragment, local);
			transition_in(pawnstats.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(winner.$$.fragment, local);
			transition_out(startbutton.$$.fragment, local);
			transition_out(stopbutton.$$.fragment, local);
			transition_out(resetbutton.$$.fragment, local);
			transition_out(stepbutton.$$.fragment, local);
			transition_out(configuration.$$.fragment, local);
			transition_out(stage.$$.fragment, local);
			transition_out(turn.$$.fragment, local);
			transition_out(scoreboard.$$.fragment, local);
			transition_out(pawnstats.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div5);
			destroy_component(winner);
			destroy_component(startbutton);
			destroy_component(stopbutton);
			destroy_component(resetbutton);
			destroy_component(stepbutton);
			destroy_component(configuration);
			destroy_component(stage);
			destroy_component(turn);
			destroy_component(scoreboard);
			destroy_component(pawnstats);
		}
	};
}

class GamePage extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1qxxtl9-style")) add_css();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default GamePage;